import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NGXLogger } from 'ngx-logger';

import { GridHelperService } from 'src/app/services/grid-helper.service';

import { FieldBaseComponent } from '../field-component.base.component';

@Component({
  selector: 'app-decimal-field',
  templateUrl: './decimal-field.component.html',
  styleUrls: ['./decimal-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DecimalFieldComponent
  extends FieldBaseComponent
  implements OnInit
{
  /** Input element reference. */
  @ViewChild('input')
  inputElement: ElementRef;
  /** Whether the field is focused. */
  focused = false;

  constructor(
    translate: TranslocoService,
    private logger: NGXLogger,
    private gridHelper: GridHelperService
  ) {
    super(translate);
  }

  /**
   * Gets the masked value.
   *
   * @returns A string representing the masked value.
   */
  get maskedValue(): string {
    return this.field().format
      ? this.gridHelper.getDecimalCellValue(
          this.control().value,
          this.field().format
        )
      : this.control().value;
  }

  /** @inheritdoc */
  focus(): void {
    // If not already focused we need to complete the focus loop with the masked control.
    if (!this.focused) {
      this.onMaskControlFocus();
      return;
    }
    this.inputElement.nativeElement.focus();
    this.inputElement.nativeElement.select();
  }

  ngOnInit(): void {
    this.addValidators();
  }

  /** @inheritdoc */
  onBlur(event: FocusEvent): void {
    if (!this.shouldBlur(event)) return;
    this.focused = false;
    this.fieldBlurred.emit(this.field());
  }

  /** @inheritdoc */
  onFocus(): void {
    this.fieldFocused.emit(this.field());
  }

  /** Handler for the mask control focused event. */
  onMaskControlFocus(): void {
    this.focused = true;
    // Push the call to focus the control until the next render cycle when it exists.
    setTimeout(() => this.focus());
  }
}
